var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-input',_vm._b({attrs:{"type":_vm.value.type,"label":_vm.$t('Content')},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}},'content-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }